import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getLinkageStatistic} from 'src/openapi/admin/apis/CrmLinkageStatisticControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import type {CrmType} from 'src/openapi/admin/models/CrmType';

type Props = {
    accountId: number,
    licenseId: number,
    crmType: CrmType,
};

export const useLinkageStatistic = ({crmType, accountId, licenseId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(
        () => apiDispatch(getLinkageStatistic({accountId, licenseId, crmType})),
        [accountId, crmType, apiDispatch, licenseId],
    );

    return useReadOnlyDataHook({
        initValue: {
            accountsPbIdsLinked: 0,
            accountsPbIdsSynced: 0,
            contactsPbIdsLinked: 0,
            contactsPbIdsSynced: 0,
            leadsPbIdsLinked: 0,
            leadsPbIdsSynced: 0,
        },
        getDispatchAction,
        shouldLoadData: false,
    });
};
